/**
 * @generated SignedSource<<894b5effe6d2369bc35d3ba530af1593>>
 * @relayHash d97baaf1b286a0fcc2e70d29590b878e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 771d1deabc796152bf24ecf54c094188e18e01c4e9c58604be9db5c1635866ca

import type { ConcreteRequest } from 'relay-runtime';
export type agentAri_activationQuery$variables = {
  cloudId: string;
  product: string;
  skip: boolean;
};
export type agentAri_activationQuery$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type agentAri_activationQuery = {
  response: agentAri_activationQuery$data;
  variables: agentAri_activationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "items": [
              {
                "kind": "Variable",
                "name": "cloudIds.0",
                "variableName": "cloudId"
              }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
          }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "product",
                "variableName": "product"
              }
            ],
            "concreteType": "TenantContextActivationId",
            "kind": "LinkedField",
            "name": "activationIdByProduct",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "active"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "agentAri_activationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentAri_activationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "771d1deabc796152bf24ecf54c094188e18e01c4e9c58604be9db5c1635866ca",
    "metadata": {},
    "name": "agentAri_activationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d7f9c2a47c8c09620aa73c741a51fc31";

export default node;
